<script>
	export let product;
	export let feel;
	import { concentration } from '../fn.mjs';
	let card;
	$: {
		product.number;
		help();
	};
	function help() {
		temp = product.number;
		if(product.number > 10) {
			product.number = 10;
		}
		add = Math.min(10 - product.number, add);
		if(add === 0 && product.number < 10) {
			add = 1;
		}
	}
	let temp = product.number;
	function add2cart_animation() {
		temp += add;
		if(add && temp <= 10) {
			let position = card.getBoundingClientRect();
			let copy = card.cloneNode(true);
			copy.style.position = 'fixed';
			copy.style.left = position.left + 'px';
			copy.style.top = position.top + 'px';
			copy.style.width = position.width + 'px';
			copy.style.height = position.height + 'px';
			copy.style.fontFamily = "nunito sans";
			copy.style.backgroundColor = "white";
			copy.style.transformOrigin = "bottom left";
			copy.style.transition = "transform 1000ms cubic-bezier(0, 0, 0, 1)";
			copy.querySelector('select').value = add;
			copy.addEventListener('transitionend', () => {
				copy.remove();
				if(product.number === 0) {
					product.addedBy.add(feel);
				}
				product.number += add;
				product.oldNumber = product.number;
				dataLayer.push({
					event: 'addToCart',
					ecommerce: {
						currencyCode: 'CAD',
						add: {
							products: [{
								name: product.clean_title,
								id: product.id,
								price: product.price.toFixed(2),
								brand: product.brand,
								category: product.type,
								variant: `${product.portions === undefined ? '' : product.portions + ' x '}${product.quantity}${product.UOM}`,
								quantity: add
							 }]
						}
					}
				});
			});
			setTimeout(() => copy.remove(), 1200);//this is a hack
			document.body.appendChild(copy);
			setTimeout(() => {
				copy.style.transform = `translate(${document.documentElement.clientWidth - position.left - .1 * position.width - 32}px, ${-position.top - position.height + .1 * position.height + 32}px) scale(.1)`;
			}, 10);
		} else {
			temp -= add;
		}
	}
	let add = 1;
	import Buttons from '../components/Buttons.svelte';
	export let style;
	export let imgs;
</script>

<style>
	.card {
		box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.3); 
		scroll-snap-align: center;
		box-sizing: border-box;
		border-radius: 8px;
		scroll-snap-stop: always;
		padding-top: 1em;
		padding-bottom: 1em;
	}
	.fml {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		height: 90%;
		justify-content: center;
	}
	.responsive {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
	}
	.img_container {
		flex: 1 0 auto;
		position: relative;
		width: 90%;
	}
	.img_container > img {
		max-height: 100%;
		max-width: 100%;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		position: absolute;
	}
	.fun {
		display: flex;
		font-family: barlow;
		font-size: 1.25em;
		text-transform: uppercase;
		justify-content: space-evenly;
		width: 100%;
	}
	h1 {
		margin-bottom: .25em;
	}
	.bottom {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 90%;
		margin-left: auto;
		margin-right: auto;
	}
	.bottom > div {
		display: flex;
	}
	.bottom > div > select {
		width: 4em;
		padding-left: 1em;
		border: 2px solid rgb(0, 107, 166);
		border-radius: 3px 0 0 3px;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		background: #FFF url(arrow-down.svg) right 15% center no-repeat;
	}
	.bottom > div > select[disabled] {
		border-color: grey;
		opacity: .5;
	}
	.bottom > p {
		font-size: 1.4em;
		text-align: end;
		margin-top: 0;
		margin-bottom: 0;
	}
	.terpenes {
		margin-top:.5em;
		margin-bottom:.5em;
		text-align: center;
		width: 90%;
	}
	.responsive > small {
		margin-bottom: 1em;
	}
	@media screen and (max-height: 900px) {
		.fml {
			flex-direction: row;
			height: 80%;
		}
		.separator {
			display: none;
		}
		.fun {
			flex-direction: column;
			align-items: center;
		}
		.img_container {
			width: unset;
			height: 100%;
		}
		.responsive {
			width: unset;
			max-width: 50%;
			margin-right: 2em;
		}
		.responsive > small {
			margin-bottom: 0.5em;
		}
	}
</style>
<div {style} bind:this={card} class="card">
	<div class="fml">
		<div class="img_container">
			<img on:click={() => imgs = product.img.map(i => product.image_paths[i])} src={'image/' + product.image_paths[product.img[0]]}>
		</div>
		<div class="responsive">
			<h1>{product.clean_title}</h1>
			<small>{product.brand}</small>
			<div class="fun">
				<div>{product.strain}</div>
				<div class="separator">|</div>
				<div>THC: {concentration(product.thc_min, product.thc_max, product.concentration_unit)}</div>
				<div class="separator">|</div>
				<div>CBD: {concentration(product.cbd_min, product.cbd_max, product.concentration_unit)}</div>
			</div>
			<div class="terpenes">{product.terpenes.join(', ')}</div>
		</div>
	</div>
	<div class="bottom">
		<div>
			<select bind:value={add} disabled={product.number === 10}>
				<option hidden={add === 0 || product.number < 10} value={0}>--</option>
				<option hidden={add === 1 || product.number > 9} value={1}>1</option>
				<option hidden={add === 2 || product.number > 8} value={2}>2</option>
				<option hidden={add === 3 || product.number > 7} value={3}>3</option>
				<option hidden={add === 4 || product.number > 6} value={4}>4</option>
				<option hidden={add === 5 || product.number > 5} value={5}>5</option>
				<option hidden={add === 6 || product.number > 4} value={6}>6</option>
				<option hidden={add === 7 || product.number > 3} value={7}>7</option>
				<option hidden={add === 8 || product.number > 2} value={8}>8</option>
				<option hidden={add === 9 || product.number > 1} value={9}>9</option>
				<option hidden={add === 10 || product.number > 0} value={10}>10</option>
			</select>
			<Buttons active={false} style="font-family: 'nunito sans'; width: 12em; margin: 0; border-radius: 0 3px 3px 0; font-size: initial;{product.number >= 10 ? 'border-color: grey; background-color: grey; opacity: .5' : ''}" contents={[`<svg style="height: 1em" viewbox="0 0 36 34"><path d="m6.48 3.79h-4.39c-.88 0-1.6-.72-1.6-1.6s.72-1.6 1.6-1.6h4.39c.88 0 1.6.72 1.6 1.6s-.72 1.6-1.6 1.6zm27.41 6.07h-26.07c-.88 0-1.6-.72-1.6-1.6 0-.89.72-1.6 1.6-1.6h26.07c.88 0 1.59.71 1.59 1.6 0 .88-.71 1.6-1.59 1.6zm-4.96 17.02h-18.96c-.88 0-1.6-.72-1.6-1.6s.72-1.6 1.6-1.6h18.96c.88 0 1.59.72 1.59 1.6s-.71 1.6-1.59 1.6zm1.01-5.54h-20.72c-.88 0-1.6-.71-1.6-1.59 0-.89.72-1.6 1.6-1.6h20.72c.88 0 1.6.71 1.6 1.6 0 .88-.72 1.59-1.6 1.59zm-19.97 5.54c-.78 0-1.46-.57-1.58-1.36l-3.49-23.09c-.14-.87.46-1.69 1.34-1.82.87-.13 1.69.47 1.82 1.34l3.49 23.09c.14.88-.46 1.69-1.34 1.82-.08.01-.16.02-.24.02zm19.97-5.54c-.17 0-.35-.02-.52-.08-.83-.29-1.28-1.2-.99-2.03l3.94-11.55c.29-.83 1.2-1.28 2.03-.99.84.28 1.28 1.19 1 2.03l-3.95 11.54c-.22.67-.85 1.08-1.51 1.08zm-20.72 9.48c0 1.36 1.1 2.45 2.45 2.45 1.36 0 2.45-1.09 2.45-2.45 0-1.35-1.09-2.45-2.45-2.45-1.35 0-2.45 1.1-2.45 2.45zm14.8 0c0 1.36 1.1 2.45 2.45 2.45 1.36 0 2.46-1.09 2.46-2.45 0-1.35-1.1-2.45-2.46-2.45-1.35 0-2.45 1.1-2.45 2.45z" fill="white"/></svg> ${product.number === 10 ? 'max in cart' : 'add to cart'}`]} fn={add2cart_animation}/>
		</div>
		<p>
		<b>${product.price.toFixed(2)}</b> <small>/ {product.portions === undefined ? '' : product.portions + ' x '}{product.quantity}{product.UOM}</small>
		</p>
	</div>
</div>